/* OWNED BY THE FOUNDATION. */
import { Link } from "react-router-dom";
import { useI18n } from "../lib/i18n";

export function Footer() {
  const { href, ui } = useI18n();
  return (
    <footer id="footer">
      <div className="in">
        <div>
          <div className="logotype">Create.<span className="red">Share.</span>Inspire.</div>
          <div className="year">{ui("footer.year")}</div>
          {/* Which copy is on the screen. In a room the answer to "mine looks
              different" is either a reload or nothing, and this is what tells
              the two apart. */}
          <div className="year build">v{__VERSION__} · {__BUILT__}</div>
        </div>
        <div className="meta">
          Tomáš Gröpl<br />
          <a href="mailto:tomas.gropl@me.com">tomas.gropl@me.com</a><br />
          <a href="tel:+420725353090">+420 725 353 090</a><br />
          Ostrava, Česká republika
        </div>
        <div className="meta">
          <Link to={href("/prehled")}>{ui("nav.overview")}</Link><br />
          <Link to={href("/p/vyroba")}>{ui("nav.production")}</Link><br />
          <Link to={href("/p/prezentace")}>{ui("nav.slides")}</Link><br />
          <Link to={href("/p/interaktivni")}>{ui("nav.interactive")}</Link><br />
          <Link to={href("/p/nastroje")}>{ui("nav.tools")}</Link>
        </div>
      </div>
    </footer>
  );
}
